module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Und ein Stern fiel vom Himmel")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("Von Brandon Witt")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Nach dem Tod seiner Frau vor vier Jahren ist Travis Bennett nur noch ein Schatten seiner selbst. Zusammen mit seinem Hund kümmert er sich um seine drei Kinder und verdient sein Geld mit einem Futtermittelladen und als Farmarbeiter. Aber jeden Tag, jede Minute, leidet er unter dieser Leere, die ihm jede Freude am Leben nimmt.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Wesley Ryan erinnert sich gerne an die kleine Stadt El Dorado in den Ozarks zurück. Er zieht in das alte Haus seiner Großeltern und führt eine Tierarztpraxis, weil er hier seine fehlgeschlagenen Beziehungen vergessen möchte. Eines frühen Morgens kommt Travis mit seinem Hund in die Praxis und weckt in Wesley Gefühle, die ihm alles andere als gelegen kommen. Denn wenn es etwas gibt, was er in seinem neuen Leben nicht brauchen kann, dann ist das ein Mann, der mit sich selbst nicht im Reinen ist und dazu noch drei Kinder am Bein hat.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Aber das Leben, so scheint es, hat andere Pläne.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98ef6232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0001.vue
// module id = 57
// module chunks = 0